import React from 'react';
import { Switch } from 'react-router-dom';

import PrivateRouteAdmin from './PrivateRoute';
import AuthRouteAdmin from './AuthRoute';
import Login from '../../pages/auth/Login';
import UserList from '../../pages/user/List';
import UserDetail from '../../pages/user/Detail';
import UserModeration from '../userModeration/listing';
import CategoryList from '../../pages/category/List';
import PromoList from '../../pages/promo/List';
import UnapprovedPromoList from '../../pages/unapproved-promo/List';
import UnapprovedPromoApproval from '../../pages/unapproved-promo/Approval';
// import AdList from "../../pages/ad/List";
// import AdCreate from "../../pages/ad/Create";
// import AdEdit from "../../pages/ad/Edit";
import Business from '../../pages/business/BusinessClaimTable/BusinessClaimTable';
import BusinessPage from '../../pages/business/Business';
import BusinessDetail from '../../pages/business/PageClaim/PageClaim';
import FreeAdsList from '../freeAd/listing';
import StaffList from '../staff/listing';
import AddressList from '../address/listing';
import TagList from '../tags/listing';
import AdList from '../advertisement/listing';
import Ad from '../advertisement/main';
import TagsPopularTagList from '../tags/popularTag/listing';
import TagsPopularTagGroupList from '../tags/popularTagGroup/listing';
import CategoryAnalytics from '../analytics/categoryAnalytics';

import ConvertPost from '../scrappedPromo/convertPost';
import UploadScrappedPromo from '../scrappedPromo/upload/upload';
import ScrappedPromoList from '../scrappedPromo/listing';
import ReceiptUploadsList from '../receiptUploads/listing';
import ReceiptUploadDetails from '../receiptUploads/details';
import HighlightsList from '../highlights/listing';

import PageListing from '../page/listing';
import PageDetails from '../page/details';
import PageAdd from '../page/add';
import Post from '../post/post';
import PostsList from '../posts/listing';
import PoiList from '../poi/listing';
import PoiAdd from '../poi/add';
import PoiDetails from '../poi/details';
import PoisPopularTagList from '../pois/popularTag/listing';
import MapListing from '../mallMaps/listing';
import PhotosMgmt from '../photoMgmt/photoMgmt';
import CommentMgmt from '../commentMgmt';

import ReviewsList from '../reviews/listing';

import ArticleWritingMain from '../../pages/article-writing/main';
import AreaMapList from '../areaMap/listing';

import { Url } from '../../common/constants';
import MobileApp from '../../pages/mobileApp/mobileApp';
import SystemStatus from '../../pages/systemStatus';
import TrendingTagsList from '../../pages/mobileApp/trendingTags/trendingTags';
import ClearCache from '../../pages/mobileApp/cacheClear/clearCachePage';
import MobileAppVersionList from '../../pages/mobileApp/mobileAppVersion/mobileAppVersion';
import MobileAppVersionAdd from '../../pages/mobileApp/mobileAppVersion/add';
import Review from '../review/review';
import GiveawayWinner from '../../pages/mobileApp/giveAwayWinner/GiveAwayWinner';
import GiveawayWinnerAdd from '../../pages/mobileApp/giveAwayWinner/add';
import CategoryPinnedPostList from '../../pages/categoryPinnedPost/categoryPinnedPost';
import MallNavigation from '../mallMaps/mallNavigation/MallNavigation';
import MasterNames from '../reviews/MasterNames/MasterNames';
import PageHighlight from '../page/pageHighlight/pageHighlight';
import Gift from '../page/vouchersAndCoupons/gift/gift';
import LoyaltyCard from '../page/loyaltyCards/loyaltyCards';
import LuckyDraw from '../page/luckyDraws/details';
import Trail from '../page/trails/details';
import ContriPoiList from '../contriPois/listing';
import ContriPoiDetails from '../contriPois/details';
import AlbumRouter from '../page/albums/router';
import SnapstyrFavs from '../snapstyrFavs';

const Routes = () => (
  <Switch>
    <AuthRouteAdmin exact path="/admin/login" component={Login} />
    <PrivateRouteAdmin exact path="/admin" component={UserList} />
    <PrivateRouteAdmin exact path="/admin/user" component={UserList} />
    <PrivateRouteAdmin exact path="/admin/user-moderation" component={UserModeration} />
    <PrivateRouteAdmin
      path="/admin/user/detail/:id"
      component={UserDetail}
    />
    <PrivateRouteAdmin
      exact
      path={Url.SnapstyrFavs}
      component={SnapstyrFavs}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/freeAds"
      component={FreeAdsList}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/business/:pageId"
      component={BusinessPage}
    />
    <PrivateRouteAdmin
      exact
      path={Url.Business}
      component={Business}
    />
    <PrivateRouteAdmin
      path={Url.BusinessDetails}
      component={BusinessDetail}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/staff"
      component={StaffList}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/address"
      component={AddressList}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/tags"
      component={TagList}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/tags/popular"
      component={TagsPopularTagList}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/tags/popular/groups"
      component={TagsPopularTagGroupList}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/advertisement"
      component={AdList}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/advertisement/:id"
      component={Ad}
    />
    {/* <PrivateRouteAdmin
      exact
      path="/admin/advertisement/edit/:id"
      component={AdEdit}
    /> */}
    <PrivateRouteAdmin
      exact
      path="/admin/analytics"
      component={CategoryAnalytics}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/category"
      component={CategoryList}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/area"
      component={AreaMapList}
    />

    <PrivateRouteAdmin path={Url.Gift} component={Gift} />
    <PrivateRouteAdmin path={Url.LuckyDraw} component={LuckyDraw} />
    <PrivateRouteAdmin path={Url.Trail} component={Trail} />
    <PrivateRouteAdmin exact path="/admin/page" component={PageListing} />
    <PrivateRouteAdmin exact path="/admin/page/add" component={PageAdd} />
    <PrivateRouteAdmin path={Url.PageHighlight} component={PageHighlight} />
    <PrivateRouteAdmin path={Url.LoyaltyCard} component={LoyaltyCard} />
    <PrivateRouteAdmin path={Url.Album} component={AlbumRouter} />
    <PrivateRouteAdmin path={Url.Post} component={Post} />
    <PrivateRouteAdmin path={Url.Review} component={Review} />
    <PrivateRouteAdmin path="/admin/page/:id" component={PageDetails} />

    <PrivateRouteAdmin
      exact
      path="/admin/posts"
      component={PostsList}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/pois"
      component={PoiList}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/contriPois"
      component={ContriPoiList}
    />
    <PrivateRouteAdmin path="/admin/contriPoi/:id" component={ContriPoiDetails} />
    <PrivateRouteAdmin
      exact
      path="/admin/pois/popular-tags"
      component={PoisPopularTagList}
    />
    <PrivateRouteAdmin exact path="/admin/poi/add" component={PoiAdd} />
    <PrivateRouteAdmin path="/admin/poi/:id" component={PoiDetails} />

    <PrivateRouteAdmin
      exact
      path="/admin/reviews"
      component={ReviewsList}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/reviews/masterNames"
      component={MasterNames}
    />
    <PrivateRouteAdmin exact path="/admin/promo" component={PromoList} />
    <PrivateRouteAdmin
      exact
      path="/admin/unapproved-promo"
      component={UnapprovedPromoList}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/unapproved-promo/approval"
      component={UnapprovedPromoApproval}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/article-writing"
      component={ArticleWritingMain}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/scrappedPromo/:scrappedPromoId/page/:pageId/post/:postId"
      component={ConvertPost}
    />
    {/* <PrivateRouteAdmin
      exact
      path="/admin/scrappedPromos"
      component={ScrappedPromo}
    /> */}
    <PrivateRouteAdmin
      exact
      path="/admin/scrappedPromos"
      component={ScrappedPromoList}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/receiptUploads"
      component={ReceiptUploadsList}
    />
    <PrivateRouteAdmin path="/admin/receiptUpload/:id" component={ReceiptUploadDetails} />
    <PrivateRouteAdmin
      exact
      path="/admin/uploadScrappedPromo"
      component={UploadScrappedPromo}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/highlights"
      component={HighlightsList}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/mobileApp"
      component={MobileApp}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/status"
      component={SystemStatus}
    />
    <PrivateRouteAdmin
      exact
      path="/admin/mobileApp/giveawayWinner"
      component={GiveawayWinner}
    />
    <PrivateRouteAdmin
      path="/admin/mobileApp/giveawayWinner/add"
      component={GiveawayWinnerAdd}
    />
    <PrivateRouteAdmin
      path="/admin/mobileApp/giveawayWinner/:id"
      component={GiveawayWinnerAdd}
    />
    <PrivateRouteAdmin
      path="/admin/mobileApp/trendingTable"
      component={TrendingTagsList}
    />
    <PrivateRouteAdmin
      path="/admin/mobileApp/cacheClear/clearCachePage"
      component={ClearCache}
    />
    <PrivateRouteAdmin
      path="/admin/mobileApp/mobileAppVersion/add"
      component={MobileAppVersionAdd}
    />
    <PrivateRouteAdmin
      path="/admin/mobileApp/mobileAppVersion/:id"
      component={MobileAppVersionAdd}
    />

    <PrivateRouteAdmin
      path="/admin/mobileApp/mobileAppVersion"
      component={MobileAppVersionList}
    />
    <PrivateRouteAdmin
      path="/admin/categoryPinnedPost/:categoryGroup/:category?"
      component={CategoryPinnedPostList}
    />
    <PrivateRouteAdmin
      path="/admin/mallMaps/:pageId/mallNavigation"
      component={MallNavigation}
    />
    <PrivateRouteAdmin
      path="/admin/mallMaps"
      component={MapListing}
    />
    <PrivateRouteAdmin
      path="/admin/photos"
      component={PhotosMgmt}
    />
    <PrivateRouteAdmin
      path="/admin/comments"
      component={CommentMgmt}
    />
  </Switch>
);

export default Routes;
